import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { js as jsBeautify } from 'js-beautify';
import ConfigureForm from './ConfigureForm';
import { storeWithExpiration } from '../../utils/common';
import { catchClientSideError } from '../../actions/common';
import {
  cancelForm,
  createConfigSettings,
  deleteConfigSettings,
  fetchConfigSettings,
  updateConfigSettings,
} from '../../actions/superadmin';

export class ConfigureFormContainer extends React.Component {
  static propTypes = {
    cancelFormAction: PropTypes.func.isRequired,
    catchClientSideErrorAction: PropTypes.func.isRequired,
    config: PropTypes.object.isRequired,
    createConfigSettingsAction: PropTypes.func.isRequired,
    datasetId: PropTypes.number.isRequired,
    deleteConfigSettingsAction: PropTypes.func.isRequired,
    fetchConfigSettingsAction: PropTypes.func.isRequired,
    isEdit: PropTypes.bool.isRequired,
    platformCode: PropTypes.string.isRequired,
    progress: PropTypes.number.isRequired,
    updateConfigSettingsAction: PropTypes.func.isRequired,
  };

  state = { configuration: '' };

  componentWillMount = () => {
    const { config, datasetId, platformCode, fetchConfigSettingsAction } = this.props;
    const token = storeWithExpiration.get('token');
    const configuration = jsBeautify(JSON.stringify(config));
    this.setState(() => ({ configuration }));
    if (platformCode !== '0') fetchConfigSettingsAction(token, datasetId, platformCode);
  };

  componentWillReceiveProps = nextProps => {
    const { config } = nextProps;
    const configuration = jsBeautify(JSON.stringify(config));
    this.setState(() => ({ configuration }));
  };

  beautifyConfigState = e => {
    e && e.preventDefault();
    this.setState(prevState => {
      const prettierConfig = jsBeautify(prevState.configuration);
      return { configuration: prettierConfig };
    });
  };

  cancelForm = e => {
    const { cancelFormAction, datasetId } = this.props;
    e && e.preventDefault();
    cancelFormAction(`/data/dataset/${datasetId}`);
  };

  createConfig = e => {
    const { catchClientSideErrorAction, createConfigSettingsAction } = this.props;
    const { configuration } = this.state;
    e && e.preventDefault();
    try {
      const body = { configuration: JSON.parse(configuration) };
      this.dispatchAction(createConfigSettingsAction, body);
    } catch (err) {
      catchClientSideErrorAction(err);
    }
  };

  deleteConfig = e => {
    const { deleteConfigSettingsAction } = this.props;
    e && e.preventDefault();
    this.dispatchAction(deleteConfigSettingsAction);
  };

  dispatchAction = (action, body = null) => {
    const { platformCode, datasetId } = this.props;
    const token = storeWithExpiration.get('token');
    action(token, platformCode, datasetId, body);
  };

  updateConfig = e => {
    const { catchClientSideErrorAction, updateConfigSettingsAction } = this.props;
    const { configuration } = this.state;
    e && e.preventDefault();
    try {
      const body = { configuration: JSON.parse(configuration) };
      this.dispatchAction(updateConfigSettingsAction, body);
    } catch (err) {
      catchClientSideErrorAction(err);
    }
  };

  updateConfigState = nextConfig => {
    this.setState(() => ({ configuration: nextConfig }));
  };

  render() {
    const { isEdit, platformCode, progress } = this.props;
    const { configuration } = this.state;

    const submitFunction = isEdit ? this.updateConfig : this.createConfig;

    return progress < 1 ? (
      <ConfigureForm
        beautifyConfigState={this.beautifyConfigState}
        cancelForm={this.cancelForm}
        configuration={configuration}
        deleteConfig={this.deleteConfig}
        isEdit={isEdit}
        platformCode={platformCode}
        submitFunction={submitFunction}
        updateConfigState={this.updateConfigState}
      />
    ) : null;
  }
}

function mapStateToProps(state) {
  const { data, superadmin, progress } = state;
  const platformCode = data.get('currPlatformCode').toString();
  const datasetId = data.get('currDataset');
  const configInfo = superadmin.get('configInfo');
  const config = configInfo.data;
  const { isEdit } = configInfo;
  return { isEdit, progress, platformCode, datasetId, config };
}

export default connect(mapStateToProps, {
  cancelFormAction: cancelForm,
  catchClientSideErrorAction: catchClientSideError,
  createConfigSettingsAction: createConfigSettings,
  deleteConfigSettingsAction: deleteConfigSettings,
  fetchConfigSettingsAction: fetchConfigSettings,
  updateConfigSettingsAction: updateConfigSettings,
})(ConfigureFormContainer);
